import React, { useRef } from 'react';
import defaultImage from "../../Assets/Images/defualtImage.png";
import "./CardLearner.scss";
import { useLocation } from "react-router-dom";

const CardLearner = () => {

    const location = useLocation();
    const cardDataArray = location.state?.cardData || [];

    const printableRef = useRef(null);

    const handlePrint = () => {
        const contentToPrint = printableRef.current;
        if (contentToPrint) {
            const printWindow = window.open('', '_blank', 'width=800,height=600');
            printWindow.document.head.innerHTML = document.head.innerHTML;
            printWindow.document.body.innerHTML = contentToPrint.innerHTML;
            printWindow.print();
        }
    };

    return (
        <div className='print'>
            <div ref={printableRef}>
                {cardDataArray.map((cardData, index) => (
                    <div className='ParentCardLearner' key={index}>
                        {cardData.academiName && (
                            <div className='CardLearner'>
                                <div className='academyName'>
                                    <span>{cardData.academiName}</span>
                                </div>
                                <div className='positionimageLearner'>
                                    <div className='imageLearner'>
                                        <img src={cardData.url?.imageBackend || defaultImage} alt='' />
                                    </div>
                                </div>
                                <div className='columnSpecifications'>
                                    <div className='rowImageNameClass'>
                                        <div className='parentName'>
                                            <div className='labelName'>
                                                <span>نام و نام خانوادگی</span>
                                            </div>
                                            <div className='name'>
                                                <span>{cardData.name}</span>
                                            </div>
                                        </div>
                                        <div className='parentClassName'>
                                            <div className='labelClassName'>
                                                <span>نام کلاس</span>
                                            </div>
                                            <div className='className'>
                                                <span>{cardData.ClassName}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='rowDateTime'>
                                        <div className='Code'>
                                            <span>{cardData.code}</span>
                                        </div>
                                        <div className='parentDate'>
                                            <div className='labelDate'>
                                                <span>زمان</span>
                                            </div>
                                            <div className='date'>
                                                <span>{cardData.day}</span>
                                            </div>
                                        </div>
                                        <div className='parentTime'>
                                            <div className='labeltime'>
                                                <span>ساعت</span>
                                            </div>
                                            <div className='time'>
                                                <span>{cardData.time}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='footerCardLearner'>
                                    <div className='parentrowFooterCardLearner'>
                                        <div className='rowFooterCardLearner'>
                                            <div className='siteName'>
                                                <span>{cardData.footer}</span>
                                            </div>
                                            <div className='imageCircle'>
                                                <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="15" cy="15" r="15" fill="#D9D9D9" />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {cardData.academiNameEn && (
                            <div className='CardLearnerEnglish'>
                                <div className='academyNameEnglish'>
                                    <span>{cardData.academiNameEn}</span>
                                </div>
                                <div className='positionimageLearner'>
                                    <div className='imageLearner'>
                                        <img src={cardData.urlEn?.imageBackend || defaultImage} alt='' />
                                    </div>
                                </div>
                                <div className='columnSpecifications'>
                                    <div className='rowImageNameClass'>
                                        <div className='parentName'>
                                            <div className='labelName'>
                                                <span>Nick name & Last name</span>
                                            </div>
                                            <div className='name'>
                                                <span>{cardData.nameEn}</span>
                                            </div>
                                        </div>
                                        <div className='parentClassName'>
                                            <div className='labelClassName'>
                                                <span>Class Name</span>
                                            </div>
                                            <div className='className'>
                                                <span>{cardData.ClassNameEn}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='rowDateTime'>
                                        <div className='Code'>
                                            <span>{cardData.codeEn}</span>
                                        </div>
                                        <div className='parentDate'>
                                            <div className='labelDate'>
                                                <span>Date</span>
                                            </div>
                                            <div className='date'>
                                                <span>{cardData.dayEn}</span>
                                            </div>
                                        </div>
                                        <div className='parentTime'>
                                            <div className='labeltime'>
                                                <span>Clock</span>
                                            </div>
                                            <div className='time'>
                                                <span>{cardData.timeEn}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='footerCardLearner'>
                                    <div className='parentrowFooterCardLearner'>
                                        <div className='rowFooterCardLearner'>
                                            <div className='siteName'>
                                                <span>{cardData.footerEn}</span>
                                            </div>
                                            <div className='imageCircle'>
                                                <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="15" cy="15" r="15" fill="#D9D9D9" />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                ))}
            </div>
            <div className='btnPrint'>
                <button onClick={handlePrint}>پرینت</button>
            </div>
        </div>
    );
};

export default CardLearner;
